import {AddToCart} from '../../cart/components/add-to-cart/AddToCart';
import {DealType} from '../models/DealSelection';
import type {ProductDetails} from '../models/ProductDetails';
import {ModalContend, ModalDetalleArticulo} from '../../ui';
import React, {useEffect, useState} from 'react';
import {ProductPurchasePanelUI} from '../ui/PurchasePanelUI';
import ProductService from '../services/ProductService';
import {BtnCloseCarrito} from '../../ui/components/navbar/NavbarStyles.elements';
import CloseIcon from '@mui/icons-material/Close';
import {usePurchaseLogic} from '../hooks/usePurchaseLogic';
import {useErrorLoadingState} from '../../helpers/hooks/useErrorLoadingState';

interface Props {
  data: {
    details: ProductDetails,
    quantity: number,
    disabled: boolean,
  };
}

export const AddToCartProxy = ({ data }: Props) => {
  const { details, quantity: _quantity, disabled } = data;
  const { loading, error, run } = useErrorLoadingState(true);
  const [deals, setDeals] = useState();
  const [modal, setModal] = useState(false);
  const [hasDealsToChose, setHasDealsToChose] = useState(false);
  const [triggerAddToCart, setTriggerAddToCart] = useState(false);

  const loadDeals = async (productCode) => {
    const productDeals = await ProductService.getProductDeals(productCode);
    setDeals(productDeals);

    const exclusiveDeal = productDeals.OFERTASEXCLUSIVAS.find(it => it.cantidad === 1);
    const haveExclusiveDeals = (exclusiveDeal && productDeals.OFERTASEXCLUSIVAS.length > 1)
      || (!exclusiveDeal && productDeals.OFERTASEXCLUSIVAS.length > 0);

    setHasDealsToChose(productDeals.LOTES.length > 0 || haveExclusiveDeals || productDeals.PROMOCIONES.length > 0);
  };

  const {
    dealSelection,
    price,
    quantity,
    discount,
    bcDiscounts,
    setDealSelection,
    setQuantity
  } = usePurchaseLogic({
    productDeals: deals
  });

  useEffect(() => {
    setQuantity(_quantity);
  }, []);

  useEffect(() => {
    if (!deals) {
      return;
    }
    if (hasDealsToChose) {
      setModal(true);
    } else {
      setTriggerAddToCart(true);
    }
  }, [deals, hasDealsToChose]);

  return (
    <div>
      {
        modal && (
          <ModalContend>
            <ModalDetalleArticulo>
              <div className="d-flex flex-row gap-2 align-content-center">
                <h3>{details.pro_nombre}</h3>
                <BtnCloseCarrito onClick={() => setModal(false)}>
                  <CloseIcon />
                </BtnCloseCarrito>
              </div>
              <ProductPurchasePanelUI
                data={{
                  deals: deals,
                  loading: false,
                  dealSelection: dealSelection,
                  quantity: quantity,
                  price: price,
                  discount: discount,
                  bcDiscounts: bcDiscounts,
                  details: data.details
                }}
                actions={{
                  onQuantityChange: setQuantity,
                  onDealSelectionChange: setDealSelection,
                  afterAddToCart: () => {
                    setTriggerAddToCart(false);
                    setModal(false);
                  }
                }}
              />
            </ModalDetalleArticulo>
          </ModalContend>
        )
      }
      <div className="d-inline-block" onClick={async () => {
        if (!disabled && !loading && !error) {
          await run(loadDeals, [details?.pro_codigo]);
        }
      }}>
        <AddToCart
          data={{
            details: details,
            bcDiscounts: bcDiscounts,
            price: price,
            quantity: _quantity, // TODO: there is something weird here
            giftProductDeal: dealSelection?.type === DealType.GIFT_DEAL && dealSelection.value,
            triggerAddToCart: triggerAddToCart,
            blockOnClickAddToCart: true,
            disabled: disabled || loading || !!error,
            loading: loading
          }}
          actions={{
            afterAddToCart: () => {
              setTriggerAddToCart(false);
            },
          }}
        />
      </div>
    </div>
  );
};